/**
 * Wrapper for HTML Dom location/history methods to allow easier mocking in tests
 */
export function locationAssign(url: string) {
  window.location.assign(url);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- copying window.history.replaceState signature
export function historyReplaceState(data: any, unused: string, url?: string | URL | null) {
  window.history.replaceState(data, unused, url);
}

export function getHostname(): string {
  return window.location.hostname;
}
